import { render } from 'preact';
import './styles/portal.scss';
import '@styles/main.scss';
import '@shared/components/buttons';
import 'bootstrap';

import { LocationProvider } from 'preact-iso';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ToastContainer } from 'react-toastify';

import { html } from '@shared/utils/rendering/html';

import { CacheManagementProvider } from './core/utils/context/cache-management-context';
import { TimeSpans } from './core/constants/utility/time-spans.constants';

import App from './app';
import { AuthProvider } from './core/utils/context/auth-context';
import { FeatureProvider } from './core/utils/features/feature-context';

if (typeof __webpack_init_sharing__ === 'function') {
    window.__initSharing = __webpack_init_sharing__;
    window.__shareScopes = __webpack_share_scopes__;
}

window.__initSharing('default');

const mountNode = document.getElementById('root');

const queryClient = new QueryClient();

render(
    html`
        <${AuthProvider}>
            <${QueryClientProvider} client=${queryClient}>
                <${CacheManagementProvider}>
                <${FeatureProvider}>
                <${LocationProvider}>
                    <${App} />
                    <${ToastContainer}
                        position="bottom-right"
                        autoClose=${TimeSpans.FiveSeconds}
                        hideProgressBar=${false}
                        newestOnTop=${false}
                        closeOnClick=${true}
                    />
                    </${LocationProvider}>
                    <${ReactQueryDevtools} initialIsOpen=${false} />
                </${FeatureProvider}>
                </${CacheManagementProvider}>

            </${QueryClientProvider}>
        </${AuthProvider}>`,
    mountNode
);
